export const formatDimensions = (size?: string): string =>
  size ? size.replace('x', '×') : ''
